
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { map as _map } from 'lodash';

const HashedTemporaryAttachmentQuery = require('./gql/hashed-temporary-attachment.query.gql');
const createSLTemporaryAttachmentMutation = require('./gql/create-temporary-attachment.mutation.gql');

interface CreateSLAttachmentInput {
  filename: string
  filetype: string
}

interface SLTemporaryAttachmentUploadFormItem {
  key: string
  value: string
}

export interface SLTemporayAttachment {
  id: string
  filename: string
  filetype: string
  uploadURL: string
  uploadForm: SLTemporaryAttachmentUploadFormItem[],
  createdAt: number
}

interface SLHashedTemporaryAttachment {
  id: string
  filename: string
  filetype: string
  filesize: number
  digest: string
  createdAt: number
}

@Injectable()
export class SLAttachmentService {

  constructor(private apollo: Apollo) { }

  hashedTemporaryAttachment(id: string): Observable<SLHashedTemporaryAttachment> {
    return this.apollo
      .query({
        query: HashedTemporaryAttachmentQuery,
        variables: {
          id
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map(result => result.data['slHashedTemporaryAttachment'] as SLHashedTemporaryAttachment));
  }

  createTemporaryAttachment(input: CreateSLAttachmentInput): Observable<SLTemporayAttachment> {
    return this.apollo
      .mutate({
        mutation: createSLTemporaryAttachmentMutation,
        variables: {
          input,
        }
      }).pipe(
      map(result => result.data['createSLTemporaryAttachment'] as SLTemporayAttachment));
  }
}
